import { render } from "./Setor.vue?vue&type=template&id=d9179a02&scoped=true"
import script from "./Setor.vue?vue&type=script&lang=js"
export * from "./Setor.vue?vue&type=script&lang=js"

import "./Setor.vue?vue&type=style&index=0&id=d9179a02&scoped=true&lang=scss"

import exportComponent from "/run/media/ctis-dev/developer/WorkSpaceFront/transparencia-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9179a02"]])

export default __exports__